import { FormMemberPost } from 'src/modules/member/models/formMemberPost';
import { FormMemberPut } from 'src/modules/member/models/formMemberPut';
import { FormMemberResponse } from 'src/modules/member/models/formMemberResponse';
import { ImportMembers } from 'src/modules/member/models/importMembers';
import AxiosInstance from 'src/shared/services/axios/interceptor';

const controller = 'FormMember';
const otherController = 'FormOther';

export const getFormMember = (id) => {
  const endpoint = `${controller}/${id}`;
  return AxiosInstance.get<FormMemberResponse>(endpoint);
};

export const getNewFormMember = (paid, localAssId) => {
  const endpoint = `${controller}/new/?paid=${paid}&localAssId=${localAssId}`;
  return AxiosInstance.get<FormMemberResponse>(endpoint);
};

export const updateFormMember = (member: FormMemberPut) => {
  const endpoint = `${controller}`;
  return AxiosInstance.put<FormMemberPut>(endpoint, member);
};
export const deleteFormMember = (id: number) => {
  const endpoint = `${controller}/${id}`;
  return AxiosInstance.delete<FormMemberResponse>(endpoint);
};

export const createFormMember = (member: FormMemberPost) => {
  const endpoint = `${controller}`;
  return AxiosInstance.post<FormMemberPost>(endpoint, member);
};

export const importMembers = (members: ImportMembers) => {
  return AxiosInstance.put<ImportMembers>(`MemberImport/ImportMembers`, members);
};

export const getFormOther = (id: number) => {
  return AxiosInstance.get<FormMemberResponse>(`${otherController}/${id}`);
};

export const getNewFormOther = (paid: boolean | undefined, localAssId: number) => {
  const endpoint = `${otherController}/new/?paid=${paid}&localAssId=${localAssId}`;
  return AxiosInstance.get<FormMemberResponse>(endpoint);
};

export const updateFormOther = (member: FormMemberPut) => {
  return AxiosInstance.put<FormMemberPut>(otherController, member);
};

export const deleteFormOther = (id: number) => {
  return AxiosInstance.delete<FormMemberResponse>(`${otherController}/${id}`);
};

export const createFormOther = (member: FormMemberPost) => {
  return AxiosInstance.post<FormMemberPost>(otherController, member);
};
